import { STATIC_ASSEST_URL } from '../../../app.config';

export const socialDefaults = [
  {
    social_type: "Facebook",
    name: "https://www.facebook.com/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/facebook-logo.png`
  },
  {
    social_type: "Instagram",
    name: "https://www.instagram.com/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/instagram-logo.png`
  },
  {
    social_type: "Twitter",
    name: "https://twitter.com/yourname or @yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/twitter-logo.png`
  },
  {
    social_type: "QQ",
    name: "123456789123",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/qq_logo.png`
  },
  {
    social_type: "Linkedin",
    name: "https://www.linkedin.com/in/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/linkedin-logo.png`
  },
  {
    social_type: "YouTube",
    name: "https://www.youtube.com/user/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/youtube-logo.png`
  },
  {
    social_type: "Google+",
    name: "https://plus.google.com/123456789",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/google-plus-logo.png`
  },
  {
    social_type: "Vkontakte",
    name: "https://vk.com/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/vkontakte-logo.png`
  },
  {
    social_type: "Pinterest",
    name: "https://www.pinterest.com/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/pinterest-logo.png`
  },
  {
    social_type: "Reddit",
    name: "https://www.reddit.com/u/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/reddit-logo.png`
  },
  {
    social_type: "Flickr",
    name: "https://www.flickr.com/photos/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/flickr-logo.png`
  },
  {
    social_type: "Skype",
    name: "yourskypename",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/skype-logo.jpg`
  },
  {
    social_type: "Snapchat",
    name: "https://www.snapchat.com/add/yourname",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/snapchat-logo.png`
  },
  {
    social_type: "Sina Weibo",
    name: "http://e.weibo.com/username",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/Sina_Weibo-logo.png`
  },
  {
    social_type: "Custom",
    name: "",
    privacy: "PU",
    img_url: `${STATIC_ASSEST_URL}/media/users/social_media_icons/photo-placeholder.png`
  }
];


// WEBPACK FOOTER //
// ./src/components/forms/SocialFormPanel/constants.js